import { render, staticRenderFns } from "./DialogTaxaServico.vue?vue&type=template&id=6ea6a410&scoped=true&"
import script from "./DialogTaxaServico.vue?vue&type=script&lang=js&"
export * from "./DialogTaxaServico.vue?vue&type=script&lang=js&"
import style0 from "./DialogTaxaServico.vue?vue&type=style&index=0&id=6ea6a410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea6a410",
  null
  
)

export default component.exports